<template>
  <div class="err404">
    <img src="../assets/404/404.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'Err404'
}
</script>
<style scoped>
.err404 {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -278px;
  margin-left: -506px;
}
</style>



// WEBPACK FOOTER //
// src/views/Err404.vue